import React, { useCallback } from "react";
import { Button, Modal, notification } from "antd";
import { TenantService } from "../../../../../Services";

export const DeleteFilter = ({ tenantName, filterId, refetchSections }) => {
	const deleteCallback = useCallback(async () => {
		const result = await TenantService.deleteFilter({
			tenantName,
			filterId
		});
		if (result.data) {
			notification.success({
				message: "Filter Deleted Successfully"
			});
			refetchSections && refetchSections();
			return;
		}

		notification.error({ message: "Error Deleting Filter" });
	}, [tenantName, filterId, refetchSections]);

	return (
		<>
			<Button
				type="danger"
				style={{
					marginLeft: "10px"
				}}
				onClick={() => {
					Modal.confirm({
						title: "Are you sure you want to delete this filter?",
						onOk: deleteCallback
					});
				}}
			>
				Delete
			</Button>
		</>
	);
};

export default DeleteFilter;
